module.exports = __webpack_public_path__ + "img/9788963711195.d80a4d49.jpg";